import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useMediaDevice } from '@elem/compPage/Oasis/hooks';
import EcoImg from 'eco-design/base/eco-img';
import { useState, useEffect } from 'react';

export default function Modal({ callback }: any) {
    const { t } = useLang('ats.B.dialog');
    const [visible, setVisible] = useState(false);
    const [isPad, setIsPad] = useState(false);
    const handleResize = () => {
        if (typeof window === 'undefined') return;
        setIsPad(window.innerWidth < 1024);
    };
    useEffect(() => {
        if (typeof window === 'undefined') return;
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const items: string[][] = [
        ['Appliance', 'DELTA 3 1000 Air', 'DELTA 3 2000 Air', 'Units'],
        ['Wi-Fi Router', '43', '80', 'hours'],
        ['Light', '41.5', '73', 'hours'],
        ['Speaker (DC)', '90', '170', 'hours'],
        ['Portable Fan(DC)', '50', '110', 'hours'],
        ['Camera', '58', '110', 'times'],
        ['Phone', '42', '80', 'times'],
        ['Display', '45', '85', 'times'],
        ['Fan', '20', '24', 'hours'],
        ['Drone', '18', '34', 'times'],
        ['Starlink', '16.3', '23.2', 'hours'],
        ['Laptop', '15', '27', 'times'],
        ['Car Fridge', '19.4', '34', 'hours'],
        ['TV', '8', '14', 'hours'],
        ['Refrigerator', '20', '40', 'hours'],
        ['PC', '8', '15', 'hours'],
        ['Coffee Maker', '1.5', '2.5', 'hours'],
        ['Rice Cooker', '1', '1.8', 'hours'],
    ];

    const handleClose = () => {
        setVisible(false);
        setTimeout(() => {
            callback();
        }, 200);
    };

    useEffect(() => {
        setTimeout(() => {
            setVisible(true);
        }, 200);
    }, []);

    return (
        <div
            className={`d3a-modal-terms ${css.modal} GtmModuleData-section ${visible ? 'visible' : ''}`}
            data-section-id={css.modal}
            data-section-title={t('title')}
        >
            <div className="mask"></div>
            <div className={`content ${visible ? 'visible' : ''} pc`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none" onClick={handleClose}>
                    <circle cx="10" cy="10" r="10" fill="black" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.76758 9.82812L6.46918 12.1265C6.17629 12.4194 6.17629 12.8943 6.46918 13.1872C6.76207 13.4801 7.23695 13.4801 7.52984 13.1872L9.82824 10.8888L12.1266 13.1872C12.4195 13.4801 12.8944 13.4801 13.1873 13.1872C13.4802 12.8943 13.4802 12.4194 13.1873 12.1265L10.8889 9.82812L13.1867 7.53033C13.4796 7.23744 13.4796 6.76256 13.1867 6.46967C12.8938 6.17678 12.4189 6.17678 12.126 6.46967L9.82824 8.76746L7.53045 6.46967C7.23755 6.17678 6.76268 6.17678 6.46979 6.46967C6.17689 6.76256 6.17689 7.23744 6.46979 7.53033L8.76758 9.82812Z"
                        fill="white"
                    />
                </svg>
                <ul className="modal-items">
                    {items.map((item, index) => {
                        return (
                            <li className={`item-${index}`}>
                                {item.map((i) => {
                                    return <p>{i}</p>;
                                })}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}
